module.exports = __webpack_public_path__ + "img/1d26f97343f87ced6ca849559057e70f.png";